var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--tally-graph-wrapper",style:({
		height: _vm.graphHeight ? _vm.graphHeight + '%' : '100%'
	})},[_c('div',{staticClass:"app--tally-graph"},_vm._l((_vm.tallyTable),function(item,index){return _c('div',{key:index,staticClass:"app--tally-graph-bar",style:({
				height: item.tally*_vm.heightUnit + 'px',
				width: _vm.widthPercent + '%'
			})},[(item.mark===true)?_c('div',{staticClass:"app--tally-graph-index"},[_c('div',{staticClass:"app--tally-graph-index-mark"},[_vm._v("|")]),_c('div',{staticClass:"app--tally-graph-index-num"},[_vm._v(_vm._s(item.unit))])]):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }